import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const baseURL = BASE_API_URL;

export const adminUserSlice = createSlice({
  name: "AdminUser",
    initialState: {
    error: false,
    TrackAdminUsers: [],
    allUsers:[],
    isLoaded: false,
    isDataSentSuccess: false,
    isDataSentFailure: false,
    trackId:null,
  },
  reducers: {
    setTrackAdminUsers: (state, { payload }) => {
      state.error = false;
      state.TrackAdminUsers = payload;
    },
    setAllUsers:(state,{payload})=>{
      state.error=false;
      state.allUsers = payload;
    },
    setError: (state) => {
      state.error = true;
    },
    setLoaded: (state, { payload }) => {
      state.isLoaded = true;
      state.isDataSentSuccess = false;
      state.isDataSentFailure = false;
     },
     setDataSuccess: (state, {payload}) => {
       state.isLoaded = false;
       state.isDataSentSuccess = payload;
       state.isDataSentFailure = false;
     },
     setDataFailure: (state, payload) => {
       state.isLoaded = false;
       state.isDataSentSuccess = false;
       state.isDataSentFailure = true;
     },
     setTrackId: (state, {payload}) => {
      state.trackId = payload;
     }
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(saveUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setTrackAdminUsers, setAllUsers, setError, setLoaded, setDataFailure, setDataSuccess, setTrackId } =
  adminUserSlice.actions;

export default adminUserSlice.reducer;

export function addAdminUser(trackId, username, assigned_roles) {
  return (dispatch) => {
    dispatch(setLoaded())
    Axios.post(
      `${baseURL}/addUser`,
      {trackId, enterpriseID:username, incoming_roles:assigned_roles},
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setDataSuccess(res.data.message))
      })
      .catch((err) => {
        dispatch(setError(err));
        dispatch(setDataFailure())
        console.error("error in adding user", err);
      });
  };
}
export const fetchUser = (eid) => {
  return (dispatch) => {
    Axios.get(`${baseURL}/adminUser/${eid}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        dispatch(setTrackAdminUsers(res.data))
      })
      .catch((err) => {
        // dispatch(setError(err));
        console.error("error is", err);
      });
  };
};

export const fetchAllUsers=(trackId)=>{
   return (dispatch) => {
    Axios.get(`${baseURL}/fetchUsers/${trackId}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        dispatch(setAllUsers(res.data))
      })
      .catch((err) => {
        console.error("error is", err);
      });
  };
};



export const saveUsers = createAsyncThunk(
  "users/saveUsers",
  async ({ changedUsers, trackId }, { rejectWithValue }) => {
    try {
      const res = await Axios.put(
        `${baseURL}/modifyUsers`,
        {
          usersToUpdate: changedUsers,
          trackId,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message || "Something went wrong"
      );
    }
  }
);

export const getTrackId = (id) => {
 return (dispatch) => {
  dispatch(setTrackId(id));
 }
}
